export function loadSetting(key, fallback) {
  try {
    const v = localStorage.getItem('mdeditor_' + key);
    return v !== null ? JSON.parse(v) : fallback;
  } catch { return fallback; }
}

export function saveSetting(key, value) {
  localStorage.setItem('mdeditor_' + key, JSON.stringify(value));
}

// --- Encrypted storage for sensitive data (tokens, keys) ---

const ENC_PREFIX = 'mdeditor_enc_';
const KEY_NAME = 'mdeditor_enckey';

async function getEncKey() {
  const stored = localStorage.getItem(KEY_NAME);
  if (stored) {
    const raw = Uint8Array.from(atob(stored), c => c.charCodeAt(0));
    return crypto.subtle.importKey('raw', raw, 'AES-GCM', false, ['encrypt', 'decrypt']);
  }
  const key = await crypto.subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt']);
  const exported = await crypto.subtle.exportKey('raw', key);
  localStorage.setItem(KEY_NAME, btoa(String.fromCharCode(...new Uint8Array(exported))));
  return key;
}

export async function saveSecret(key, value) {
  const encKey = await getEncKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(JSON.stringify(value));
  const encrypted = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, encKey, encoded);
  const payload = { iv: btoa(String.fromCharCode(...iv)), data: btoa(String.fromCharCode(...new Uint8Array(encrypted))) };
  localStorage.setItem(ENC_PREFIX + key, JSON.stringify(payload));
}

export async function loadSecret(key, fallback) {
  try {
    const stored = localStorage.getItem(ENC_PREFIX + key);
    if (!stored) return fallback;
    const { iv, data } = JSON.parse(stored);
    const encKey = await getEncKey();
    const ivBytes = Uint8Array.from(atob(iv), c => c.charCodeAt(0));
    const dataBytes = Uint8Array.from(atob(data), c => c.charCodeAt(0));
    const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: ivBytes }, encKey, dataBytes);
    return JSON.parse(new TextDecoder().decode(decrypted));
  } catch { return fallback; }
}
